import styled from "styled-components";

export const Container = styled.div`
  .chip_badge {
    padding: 0px;
    height: 20px;
    font-family:
      "Inter", "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
      "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
    font-size: 10px;
    color: white;
    font-weight: 700;
    line-height: 12.1px;
    border-radius: 20px;
    text-transform: uppercase;
  }
`;
